import{a as e}from"./chunk-LWM7TK5F.js";import{n as o,o as r}from"./chunk-3QROWZCZ.js";var f=new o({locale:[e,r]});export{f as a};
